/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPcDesktopIcon20Solid = forwardRef('TechPcDesktopIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11 1a2 2 0 0 0-2 2v.75h3.5a3.75 3.75 0 0 1 3.75 3.75v5a3.751 3.751 0 0 1-3.146 3.702A2.245 2.245 0 0 1 13.016 18H17a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-6Z" }),
        React.createElement("path", { d: "M15 7.7A2.7 2.7 0 0 0 12.3 5H3.7A2.7 2.7 0 0 0 1 7.7v4.6A2.7 2.7 0 0 0 3.7 15H6v1H5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-1v-1h2.3a2.7 2.7 0 0 0 2.7-2.7V7.7Z" })));
});
